import { useLocation } from "@reach/router"
import { graphql, useStaticQuery } from 'gatsby';
import * as React from "react";

import Masthead from 'components/Masthead';
import useLiveData from 'hooks/useLiveData';

const MastheadProvider = (props) => {
	const location = useLocation();
	const isPaginationPage = location?.pathname?.match(/\/page-\d+\/$/);
	// const paginationNumber = isPaginationPage ? parseInt(location?.pathname?.match(/\/page-(\d+)\//)?.[1], 10) : undefined;
	const data = useStaticQuery(graphql`
		query MastheadQuery {
		  allContentPage(
		    filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}}
		  ) {
		    edges {
		      node {
		        uri
		        additionalFields
		      }
		    }
		  }
		  allGallery {
			edges {
			  node {
				id
				slides {
				  image
				}
			  }
			}
		  }
		}
  `);

	const { status: providerStatus, response: providerResponse, visibilityChange } = useLiveData({
		type: 'ContentPage',
		apiParams: {
			archived: false,
			approved: true,
			deleted: false,
			_include: "additionalFields",
		},
		staticData: data,
		onlyNew: true,
	});

	const { response: galleryProviderResponse, galleryVisibilityChange } = useLiveData({
		type: 'Gallery',
		apiParams: {
			archived: false,
			approved: true,
			deleted: false,
			_include: "slides",
		},
		staticData: data,
		onlyNew: true,
	});

	if (!location?.pathname) return null;
	let uri = location.pathname;

	if (location?.pathname && (location.pathname.slice(-1) !== '/')) {
		uri = `${location.pathname}/`;
	}

	// check if page is a pagination page, if so use the masthead of the main page
	if (isPaginationPage) {
		uri = uri.replace(/\/page-\d+\/$/, '/');
	}

	const { edges } = data.allContentPage;
	const nodes = edges.map(({ node }) => node);
	let pages = nodes;

	if (providerResponse && providerResponse.data.length > 0) {
		pages = providerResponse.data;
	}
	if (providerResponse && visibilityChange) pages = providerResponse.data;

	const page = pages.filter(item => item.uri === uri).shift();

	if(!page)return null;

	const mastheads = (page?.additionalFields?.mastheads ? JSON.parse(page.additionalFields.mastheads) : []);
	let mastheadItem;
	if (mastheads.length > 0) {
		// match the masthead
		const matched = mastheads[0];
		mastheadItem = matched;
	}
	
	const galleryID = page?.additionalFields?.mastheadGallery;

	let gallery = null;

	if (galleryID) {
		const { edges: galleryEdges } = data.allGallery;

		const galleryNodes = galleryEdges.map(({ node }) => node);
		let galleries = galleryNodes;

		if (galleryProviderResponse && galleryProviderResponse.data.length > 0) {
			galleries = galleryProviderResponse.data;
		}
		if (galleryProviderResponse && galleryVisibilityChange) galleries = galleryProviderResponse.data;

		gallery = galleries.filter(item => item.id === galleryID).shift();
	}

	if (mastheads.length === 0 && providerStatus >= 2) return null;
	return ( 
		<Masthead 
			size={mastheadItem?.size} 
			image={mastheadItem?.image} 
			video={mastheadItem?.video} 
			title={mastheadItem?.title} 
			subtitle={mastheadItem?.subtitle} 
			body={mastheadItem?.body}
			gallery={gallery}
		/>
	)
};

export default MastheadProvider;